import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useMediaQuery } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { postRequest } from "../../api/apiServices";
import { updateCandidateDescription } from "../../api/apiList";
import Toast from "../../utils/Toast";
import Loader from "../../utils/Loading";
import "../../styles/dialog-premium.css";

interface NotNowPopupProps {
  open: boolean;
  userID: number;
  onClose: () => void;
  existingDescription?: string | null;
  onUpdated?: (newDescription: string) => void;
}

const NotNowPopup: React.FC<NotNowPopupProps> = ({
  open,
  userID,
  onClose,
  existingDescription,
  onUpdated,
}) => {
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");

  const placeholderText =
    "- When can we come back to you?\n- Under what circumstances will you be interested?\n- Can we save your info?";

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    handleSubmit,
  } = useFormik({
    initialValues: { description: existingDescription || "" },
    validationSchema: Yup.object({
      description: Yup.string().required("Description is required."),
    }),
    onSubmit: async (value) => {
      setLoading(true);
      const response = await postRequest(updateCandidateDescription, {
        id: userID,
        notNowInfo: value.description,
      });
      onUpdated && onUpdated(value.description);
      Toast(
        response?.data?.statusMessage || "Description Updated Successfully"
      );
      setLoading(false);
      onClose();
    },
  });

  if (loading) return <Loader />;

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="premium-modal-root"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      aria-labelledby="not-now-popup-title"
    >
      <div
        className={`premium-modal-panel ${isMobile ? "" : "premium-modal-panel--wide"}`}
      >
        <div className="premium-dialog-header">
          <h2 id="not-now-popup-title" className="premium-dialog-title">
            Not Now — Follow Up
          </h2>
          <button
            type="button"
            className="premium-dialog-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseRoundedIcon sx={{ fontSize: 18 }} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="premium-dialog-body">
            <label htmlFor="description" className="premium-dialog-label">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              rows={isMobile ? 6 : 10}
              className="premium-dialog-textarea"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder={values.description ? "" : placeholderText}
            />
            {touched.description && errors.description && (
              <div className="premium-dialog-error">{errors.description}</div>
            )}
          </div>

          <div className="premium-dialog-footer">
            <button
              type="button"
              className="premium-dialog-btn premium-dialog-btn--cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="premium-dialog-btn premium-dialog-btn--confirm"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NotNowPopup;
